<template>
  <DsfFormControlBox class="ds-system" :owner="_self">
    <template v-slot:simple>
      {{ value }}
    </template>
    <template v-slot:content>
      <template v-if="isDesign">
        [当前用户id]
      </template>
      <template v-else>
        {{ value }}
      </template>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfUpdateUserId",
  mixins: [$mixins.formControl],
  ctrlCaption: "修改人ID",
  props: {
    caption: {
      type: String,
      default: dsf.config.kw.updateuserid,
    },
    label: {
      type: String,
      default: "修改人ID",
    },
    simple: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    allowPost:{
      type:Boolean,
      default:false
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("system-meta-data", {
          code: dsf.config.kw.updateuserid,
          valueAttributes: [
            {
              name: "修改人ID",
              code: dsf.config.kw.updateuserid,
              type: dsf.metadata.getDataType("string"),
              length: "50",
              defaultValue: null,
              unit: null,
            },
          ],
        });
      },
    },
    //设计器复制粘贴组件时不改变caption
    desCopyedChangeCaption:{
      type:Boolean,
      default:false
    }
  },
});
</script>
